import { type RefObject } from "react";
import { Link } from "react-router-dom";

interface VideoPlayerCardProps {
  videoId: string;
  videoSrc: string;
  videoRef: RefObject<HTMLVideoElement>;
}

function VideoPlayerCard({
  videoId,
  videoSrc,
  // deceptionFlag,
  videoRef,
}: VideoPlayerCardProps) {
  return (
    <section className="">
      {/* BREADCRUMB */}
      <div className="video-header-breadcrumb">
        <Link to="/videos">
          Dashboard
        </Link>

        <span className="breadcrumb-separator">
          ›
        </span>
        <strong>{ `PT-${videoId?.replace(/-/g, "").substring(0, 5).toUpperCase()}-A`}</strong>
      </div>

      {/* TITLE */}
      <div className="video-header">
        <h2 className="video-header-title">
          AI-POWERED REVIEW
        </h2>

        <div className="video-header-patient">
          <span className="video-header-label">
            Patient Name:
          </span>

          <strong>{"Malik Vance"}</strong>
        </div>
      </div>

      <video
        ref={videoRef}
        className="video"
        controls
        preload="metadata"
        src={videoSrc}
      />
    </section>
  );
}

export default VideoPlayerCard;